import(/* webpackMode: "eager" */ "/vercel/path0/components/Blocks/Main.js");
import(/* webpackMode: "eager" */ "/vercel/path0/components/Elements/AnimatedBgs/index.js");
import(/* webpackMode: "eager" */ "/vercel/path0/components/Fonts/Font.js");
import(/* webpackMode: "eager" */ "/vercel/path0/components/Layout/Layout.js")